import type { FormButton } from "@/components/form/BasicForm"
import BootstrapButton from "@/components/form/BootstrapButton"
import Icon from "@/components/Icon"
import { faArrowRotateLeft, faSave } from "@fortawesome/free-solid-svg-icons"
import { computed, onMounted, onUnmounted, reactive } from "vue"
import { useVtsFormContext, VtsFormContext } from "./context"

export function useVtsFormButtons() {
	const context = reactive<VtsFormContext>(useVtsFormContext())
	const canEdit = () => context.canEdit

	onMounted(() => window.addEventListener("keydown", context.handleSaveHotkey))
	onUnmounted(() => window.removeEventListener("keydown", context.handleSaveHotkey))

	return computed<FormButton[]>(() => {
		const buttons: FormButton[] = []

		if(context.type === "create") {
			buttons.push({
				id: "reset",
				validateForm: false,
				onSubmit: () => context.resetCreationForm(),
				render: (btnProps) => (
					<BootstrapButton color="danger" {...btnProps}>
						<Icon icon={faArrowRotateLeft} />
						Reset Log
					</BootstrapButton>
				),
			})
		}else {
			buttons.push({
				id: "cancel",
				validateForm: false,
				onSubmit: () => context.cancel(),
				render: (btnProps) => (
					<BootstrapButton color="secondary" {...btnProps}>
						{canEdit() ? "Cancel" : "Close"}
					</BootstrapButton>
				),
			})
		}
		if (canEdit()) {
			buttons.push({
				id: "submit",
				validateForm: true,
				onSubmit: () => context.save(),
				render: (btnProps) => (
					<BootstrapButton id={context.saveButtonId} color="primary" title="Hotkey: Ctrl+S" {...btnProps}>
						<Icon icon={faSave} />
						{context.type === "create" ? "Create" : "Save"} Log
					</BootstrapButton>
				),
			})
		}

		return buttons
	})
}
